import React from 'react';
import CheckBoxGroup from '../../../../../components/input/CheckBoxGroup';
import { BRAND_DETAIL_CHART_CHECKBOX_LIST } from '../../../../../constants/service/app/brandConstants';
import Button from '../../../../../components/Button';
import './BrandDetailStatisticSearch.scss';

const BrandDetailStatisticSearch = (props) => {
  const { storeId, keyword, setData, getBrandDetailStatistic } = props;
  const { dataTypeList, dateRange } = keyword;

  return (
    <div className="brand-detail-statistic-search">
      <div className="data-type-checkbox-group">
        {/*통계 데이터 종류*/}
        <CheckBoxGroup
          label="통계 데이터 종류"
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dataTypeList'],
              value,
            })
          }
          list={BRAND_DETAIL_CHART_CHECKBOX_LIST}
          name="rejectTypeList"
        />
      </div>

      {/*기간 설정 버튼*/}
      <div className="data-period-button-group">
        <Button
          color={dateRange === 1 ? 'primary' : 'gray'}
          text="어제"
          onClick={() => {
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dateRange'],
              value: 1,
            });
          }}
        />

        <Button
          color={dateRange === 3 ? 'primary' : 'gray'}
          text="3일"
          onClick={() => {
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dateRange'],
              value: 3,
            });
          }}
        />

        <Button
          color={dateRange === 7 ? 'primary' : 'gray'}
          text="1주일"
          onClick={() => {
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dateRange'],
              value: 7,
            });
          }}
        />

        <Button
          color={dateRange === 30 ? 'primary' : 'gray'}
          text="1개월"
          onClick={() => {
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dateRange'],
              value: 30,
            });
          }}
        />

        <Button
          color={dateRange === 90 ? 'primary' : 'gray'}
          text="3개월"
          onClick={() => {
            setData({
              path: ['brandDetail', 'statistic', 'keyword', 'dateRange'],
              value: 90,
            });
          }}
        />
      </div>

      {/*검색 버튼*/}
      <div className="search-bottom">
        <Button
          text="검색"
          color="primary"
          disabled={!dataTypeList.length || !dateRange}
          onClick={() => {
            getBrandDetailStatistic({
              storeId,
              dataTypeList,
              dateRange,
            });
          }}
        />
      </div>
    </div>
  );
};

export default BrandDetailStatisticSearch;
